let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fT7dt")).then(() => parcelRequire('9Lwfw'));